var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7857 15.7142H14.25V8.1249C14.25 4.97534 11.9219 2.37266 8.89286 1.93963V1.07132C8.89286 0.57802 8.49331 0.178467 8 0.178467C7.5067 0.178467 7.10714 0.57802 7.10714 1.07132V1.93963C4.07813 2.37266 1.75 4.97534 1.75 8.1249V15.7142H1.21429C0.819196 15.7142 0.5 16.0334 0.5 16.4285V17.1428C0.5 17.241 0.580357 17.3213 0.678571 17.3213H5.5C5.5 18.7008 6.62054 19.8213 8 19.8213C9.37947 19.8213 10.5 18.7008 10.5 17.3213H15.3214C15.4196 17.3213 15.5 17.241 15.5 17.1428V16.4285C15.5 16.0334 15.1808 15.7142 14.7857 15.7142ZM8 18.3928C7.40848 18.3928 6.92857 17.9128 6.92857 17.3213H9.07143C9.07143 17.9128 8.59152 18.3928 8 18.3928ZM3.35714 15.7142V8.1249C3.35714 6.88383 3.83929 5.71865 4.71652 4.84141C5.59375 3.96418 6.75893 3.48204 8 3.48204C9.24107 3.48204 10.4063 3.96418 11.2835 4.84141C12.1607 5.71865 12.6429 6.88383 12.6429 8.1249V15.7142H3.35714Z",
    fill: "#002E66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.4ba8aecf1b8f2cf81263c75489e1175a.svg";
export { ForwardRef as ReactComponent };